import template from './equipment-details.component.html';

class EquipmentDetailsController {
  constructor() {
    'ngInject';
  }
}

export const EquipmentDetailsComponent = {
  template,
  bindings: {
    equipmentData: '<'
  },
  controller: EquipmentDetailsController,
  controllerAs: 'vm'
};
